import { useState, useEffect } from "react";
import Aside from "./components/Aside/Aside";
import Members from "./pages/Members/Members";
import Home from "./pages/Home/Home";
import AllJobs from "./pages/AllJobs/AllJobs";
import NewJob from "./pages/NewJob/NewJob";

import "./style.scss";
import { useWPAjax } from "../../../wp-utils/v1";
import Profile from "./pages/Profile/Profile";

const Dashboard = ({ nonce }) => {
  const [page, setPage] = useState("home");
  const [state, setState] = useState({ jobs: [], nonce });
  const { data: auth, isLoading } = useWPAjax("ajax_request_handler", { nonce, model: "Users", method: "get_auth" });
  const { data, error, isLoading: jobFetching, refetch } = useWPAjax("ajax_request_handler", { method: "get_all_job_posts", model: "JobPost", nonce }, state.jobs?.length > 1);
  const { data: members, isLoading: memberFetching, error: memberError, refetch: refetchMember } = useWPAjax("ajax_request_handler", { method: "getUsers", model: "Users", nonce }, members?.length);

  useEffect(() => {
    if (!isLoading && auth) {
      setState((state) => ({ ...state, auth }));
      window.auth = auth;
    }
  }, [auth, isLoading]);

  // fetch all jobs
  useEffect(() => {
    if (data) {
      setState((state) => {
        return { ...state, jobs: data };
      });
    }
  }, [data, error]);

  // fetch members
  useEffect(() => {
    if (members) {
      setState((state) => {
        return { ...state, members };
      });
    }
  }, [members, memberError]);

  if (isLoading) {
    return (
      <div role="status" className="mt-10 pt-10 animate-pulse mb-10">
        <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 max-w-[640px] mb-2.5 mx-auto" />
        <div className="h-2.5 mx-auto bg-gray-300 rounded-full dark:bg-gray-700 max-w-[540px]" />
        <div className="flex items-center justify-center mt-4">
          <svg className="w-8 h-8 text-gray-200 dark:text-gray-700 mr-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z" />
          </svg>
          <div className="w-20 h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 mr-3" />
          <div className="w-24 h-2 bg-gray-200 rounded-full dark:bg-gray-700" />
        </div>
        <span className="sr-only">Loading...</span>
      </div>
    );
  }

  if (!auth?.user) {
    // window.location.href = window.location.origin;
  }

  return (
    <div className="py-5 flex flex-col md:flex-row">
      <>
        <Aside page={page} setPage={setPage} state={state} />
        <div className="p-4 flex-1 ">
          {page === "members" && (
            <Members isLoading={memberFetching} refetch={refetchMember} page={page} auth={auth} nonce={nonce} members={state.members?.filter((member) => member.is_approved)} setState={setState} />
          )}
          {page === "member-applications" && (
            <Members page={page} refetch={refetchMember} isLoading={memberFetching} auth={auth} nonce={nonce} members={state.members?.filter((member) => !member.is_approved)} setState={setState} />
          )}
          {page === "home" && <Home state={state} />}
          {page === "jobs" && <AllJobs refetch={refetch} isLoading={jobFetching} state={state} setState={setState} nonce={nonce} />}
          {page === "new-job-post" && <NewJob state={state} setState={setState} nonce={nonce} />}
          {page === "profile" && <Profile state={state} auth={auth} setState={setState} member={auth?.data || {}} nonce={nonce} />}
        </div>
      </>
    </div>
  );
};

export default Dashboard;
